const TABLE_DATA_ATTRIBUTES = {
  "NAME":           "data-name",
  "TYPE":           "data-type",
  "DESCRIPTION":    "data-description",
  "INDEX":          "data-index",
  "LABEL":          "data-label",
  "SORT_CLASS":     "sorted"
};

export { TABLE_DATA_ATTRIBUTES };
